import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resource } from '@util/resource';
import { DWS } from '@interfaces/dws';

@Injectable({
  providedIn: 'root'
})
export class WinesPreferencesService {

  constructor() {
  }

  list(page: number = 0, count: number = 999999): Observable<DWS.Page<DWS.WinePreference>> {
    return resource('crm://wine-preferences')
      .params(
        { page, count }
      )
      .get<DWS.Page<DWS.WinePreference>>();
  }
}
